import { Request } from '~src/httpClient/serverApi/requests/Request';
import { IEmptyResult } from '~src/httpClient/serverApi/types/IResponse';

export type RunLinkedTasksParams = {
  readonly ids: string[];
}

export class RunLinkedTasksRequest extends Request<RunLinkedTasksParams, IEmptyResult> {
  constructor(params: RunLinkedTasksParams) {
    super('runLinkedTasks', params);
  }
}
